module.exports = __webpack_public_path__ + "img/sponsor-carousel-mobile.3e5b7728.jpg";